<script>
import { usePageField } from '@voix/composables/usePageField'

export default {
  props: {
    topBackgroundColor: {
      type: String,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
    },
    inputBackgroundColor: {
      type: String,
      required: false,
    },
    inputColor: {
      type: String,
      required: false,
    },
    buttonBackgroundColor: {
      type: String,
      required: false,
    },
    buttonColor: {
      type: String,
      required: false,
    },
    menu: {
      type: Object,
      required: false,
      default: () => ({ menu_items: [] }),
    },
    legalMenu: {
      type: Object,
      required: false,
      default: () => ({ menu_items: [] }),
    },
  },

  setup() {
    const pageField = usePageField()
    const sapphireFooter = ref(false)
    const hideFooterNewsletter = pageField.get('hideFooterNewsletter', false)

    return {
      sapphireFooter,
      hideFooterNewsletter,
    }
  },

  computed: {
    agentLoggedIn() {
      const agencyCookie = useCookie('atlantis-travel-agent')
      if (agencyCookie.value)
        return true

      return false
    },

  },

  mounted() {
    // TODO: Need to rethink the $bus
    // window.bus.$on('sapphire-replacement', () => {
    //   this.sapphireFooter = true
    // })
  },

  methods: {
    toggleMobileMenuItem(item) {
      if (!item.open)
        this.$set(item, 'open', true)
      else
        item.open = false
    },
    logOutTravelAgent() {
      const atlantisTravelAgentCookie = useCookie('atlantis-travel-agent')
      atlantisTravelAgentCookie.value = null
      window.location.href = '/travelagent'
    },

    stringToSlug(str) {
      if (!str)
        return ''

      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      const to = 'aaaaeeeeiiiioooouuuunc------'
      for (let i = 0, l = from.length; i < l; i++)
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))

      str = str
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    },

    footerChildClasses(name) {
      const classes = [`footer-nav-${this.stringToSlug(name)}`]

      if (this.$voix.breakpoint.value === 'mobile' || this.$voix.breakpoint.value === 'tablet')
        classes.push('hidden')

      return classes
    },
  },
}
</script>

<template>
  <div class="bg-white" :class="{ 'pt-64': sapphireFooter }">
    <slot name="newsletter-signup">
      <ClientOnly v-if="!hideFooterNewsletter.value">
        <NewsletterFooterSignup
          :top-background-color="topBackgroundColor"
          :background-color="backgroundColor"
          :input-background-color="inputBackgroundColor"
          :input-color="inputColor"
          :button-background-color="buttonBackgroundColor"
          :button-color="buttonColor"
        />
      </ClientOnly>
    </slot>
    <footer class="small-container py-4 md:py-16 relative z-10">
      <div class="pb-16 pt-4 font-sans tracking-footer-links">
        <div
          class="flex flex-col md:flex-row md:items-start text-2xs justify-center"
        >
          <ul
            v-for="(topMenuItem, key) in menu
              .menu_items"
            :key="topMenuItem.id"
            class="flex flex-col justify-center mb-3 md:px-0 w-full md:w-1/6"
          >
            <li
              class="uppercase border-b md:border-b-0 border-glueblue-700 px-4 pb-4 md:pb-0 mb-2 md:mb-0 w-full md:w-auto text-glueblue-700"
            >
              <div class="flex justify-between items-center md:items-start">
                <a
                  v-cloak
                  :href="topMenuItem.permalink"
                  :rel="topMenuItem.rel"
                  class="text-glueblue-700 text-sm md:w-40 pr-8"
                >
                  {{ topMenuItem.name }}
                </a>
                <div
                  class="md:hidden text-2xs"
                  @click="
                    toggleMobileMenuItem(
                      menu.menu_items[key],
                    )
                  "
                >
                  <i
                    v-if="topMenuItem.children.length"
                    class="icon-chevron-down"
                  >
                    &nbsp;
                  </i>
                </div>
              </div>

              <div
                class="flex flex-col md:flex-row justify-center mb-16 font-sans2 text-sm md:hidden"
                :class="{
                  hidden: !topMenuItem.open,
                }"
              >
                <ul class="w-full mr-4 last:mr-0">
                  <li
                    v-for="childMenuItem in topMenuItem.children"
                    :key="childMenuItem.id"
                    class="py-1"
                  >
                    <a
                      :href="childMenuItem.permalink"
                      :rel="childMenuItem.rel"
                      class="text-glueblue-700"
                    >
                      {{ childMenuItem.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <div class="md:hidden mt-6 mx-8 py-2 text-xs uppercase text-gray-400">
            Also check out
          </div>
          <ul
            class="md:hidden flex justify-start space-x-8 mx-8 mb-3 py-4 border-y border-gray-300 text-xs uppercase"
          >
            <li>
              <a href="/blog" class="text-gray-800 flex items-center space-x-1">
                <svg
                  width="26"
                  height="18"
                  viewBox="0 0 26 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.9902 1.86388C22.8386 0.712291 20.964 0.71179 19.8124 1.86388L17.7646 3.9112L14.3088 7.36696C14.1982 7.47762 14.1186 7.61581 14.0775 7.76651L12.3101 13.54L18.0866 11.7755C18.2378 11.735 18.3755 11.6549 18.4861 11.5442L21.9419 8.08846L23.9892 6.04064C25.1217 4.90807 25.1217 2.99494 23.9892 1.86288L23.9902 1.86388ZM19.3848 2.99994L22.8546 6.46973L21.9429 7.38148L18.4731 3.9117L19.3848 2.99994ZM14.45 8.2632C14.4586 8.29174 14.4666 8.32128 14.4746 8.35182C14.5256 8.54258 14.5892 8.78041 14.8756 9.06681C15.1605 9.3517 15.4019 9.42029 15.5956 9.47537C15.7689 9.52444 15.905 9.56349 16.0983 9.75626C16.2911 9.94902 16.3301 10.0857 16.3792 10.259C16.4343 10.4527 16.5029 10.694 16.7878 10.9789C17.0742 11.2653 17.312 11.3289 17.5027 11.38C17.5333 11.388 17.5628 11.396 17.5914 11.4045L15.3177 12.099L13.7546 10.5358L14.45 8.2632ZM13.5884 11.0781L14.775 12.2647L13.0656 12.7869L13.5884 11.0781ZM18.1767 11.1477C17.9649 10.986 17.7836 10.9369 17.6319 10.8963C17.4652 10.8518 17.333 10.8162 17.1418 10.625C16.9505 10.4337 16.9099 10.2955 16.8609 10.1223C16.8058 9.9285 16.7372 9.68716 16.4523 9.40227C16.1674 9.11738 15.9361 9.05179 15.7323 8.99371C15.5591 8.94464 15.4229 8.90558 15.2296 8.71282C15.0379 8.52105 15.0028 8.38937 14.9582 8.22264C14.9177 8.07093 14.8686 7.88968 14.7069 7.67789L18.1191 4.26569L21.5889 7.73547L18.1767 11.1477ZM23.6362 5.68815L23.2086 6.11574L19.7388 2.64596L20.1664 2.21837C21.1232 1.26155 22.6794 1.26205 23.6362 2.21837C24.5765 3.15866 24.5765 4.74785 23.6362 5.68815ZM18.0916 12.7739H18.5922V13.5325C18.5922 14.8127 17.5508 15.8542 16.2705 15.8542H8.59547L3.98862 19V15.8542H3.3217C2.04144 15.8542 1 14.8127 1 13.5325V4.62518C1 3.34492 2.04144 2.30348 3.3217 2.30348H17.6845V2.80417H3.3217C2.31732 2.80417 1.50069 3.6213 1.50069 4.62518V13.532C1.50069 14.5363 2.31782 15.353 3.3217 15.353H4.48931V18.0512L8.44076 15.353H16.27C17.2744 15.353 18.0911 14.5358 18.0911 13.532L18.0916 12.7739ZM14.6621 5.0738H3.25V4.57311H14.6621V5.0738ZM12.9675 7.25531H3.25V6.75462H12.967L12.9675 7.25531ZM12.1834 9.43682H3.25V8.93613H12.1829L12.1834 9.43682ZM10.8971 11.6183H3.25V11.1176H10.8971V11.6183ZM3.25 13.2981H10.8971V13.7988H3.25V13.2981Z"
                    fill="#989898"
                    stroke="#989898"
                    stroke-width="0.5"
                  />
                </svg>

                <span>Atlantis Stories</span>
              </a>
            </li>
            <li>
              <a
                href="/photo-gallery"
                class="text-gray-800 flex items-center space-x-1"
              >
                <svg
                  width="25"
                  height="18"
                  viewBox="0 0 25 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.1308 4.19079V15.8092C22.1308 16.3337 21.7037 16.7608 21.1792 16.7608H20.4867V16.2011H21.1792C21.3953 16.2011 21.571 16.0253 21.571 15.8092V4.19079C21.571 3.97472 21.3953 3.79894 21.1792 3.79894H4.19079C3.97472 3.79894 3.79894 3.97472 3.79894 4.19079V4.91852H3.23915V4.19079C3.23915 3.66627 3.66627 3.23915 4.19079 3.23915H21.1792C21.7037 3.23915 22.1308 3.66627 22.1308 4.19079ZM23.4183 1H6.42995C5.90543 1 5.47831 1.42712 5.47831 1.95164V2.67937H6.0381V1.95164C6.0381 1.73556 6.21387 1.55979 6.42995 1.55979H23.4183C23.6344 1.55979 23.8102 1.73556 23.8102 1.95164V13.5701C23.8102 13.7861 23.6344 13.9619 23.4183 13.9619H22.7259V14.5217H23.4183C23.9429 14.5217 24.37 14.0946 24.37 13.5701V1.95164C24.37 1.42712 23.9429 1 23.4183 1ZM14.5255 8.24366C13.5358 8.24366 12.7303 9.0492 12.7303 10.0389C12.7303 11.0286 13.5358 11.8341 14.5255 11.8341C15.5153 11.8341 16.3208 11.0286 16.3208 10.0389C16.3208 9.0492 15.5153 8.24366 14.5255 8.24366ZM11.3711 16.4205C10.1765 16.6041 8.94445 16.7933 7.83103 16.8683V17.4292C8.97804 17.3548 10.237 17.1611 11.4562 16.9736C13.8454 16.6063 16.3079 16.2279 17.8602 16.762V16.1736C16.1965 15.6793 13.8437 16.0404 11.3711 16.4205ZM19.8917 6.42995V18.0484C19.8917 18.5729 19.4646 19 18.94 19H1.95164C1.42712 19 1 18.5729 1 18.0484V6.42995C1 5.90543 1.42712 5.47831 1.95164 5.47831H18.94C19.4646 5.47831 19.8917 5.90543 19.8917 6.42995ZM19.3319 6.42995C19.3319 6.21387 19.1561 6.0381 18.94 6.0381H1.95164C1.73556 6.0381 1.55979 6.21387 1.55979 6.42995V18.4402H5.42842L5.47488 15.8635C4.56635 15.8607 3.73226 15.7667 3.01741 15.5299V14.9359C3.70595 15.2007 4.54899 15.3037 5.48496 15.3054L5.57285 10.4218L3.66341 12.3312C3.64773 12.3469 3.62702 12.3548 3.60631 12.3548C3.59903 12.3548 3.5912 12.3536 3.58392 12.3514C3.55537 12.343 3.5341 12.32 3.52738 12.2915C3.374 11.6175 3.57384 10.9245 4.06142 10.4364C4.21424 10.2835 4.39001 10.1576 4.5809 10.0624H2.65635C2.62668 10.0624 2.59981 10.0462 2.58526 10.0204C2.5707 9.99468 2.57182 9.96277 2.58749 9.93814C2.95528 9.35316 3.58728 9.00442 4.27694 9.00442C4.49301 9.00442 4.70629 9.03968 4.90894 9.10686L3.54865 7.74657C3.52794 7.72586 3.5201 7.69507 3.52794 7.66652C3.53634 7.63797 3.55929 7.6167 3.58784 7.60998C4.26182 7.4566 4.95484 7.65645 5.44298 8.14402C5.66241 8.36346 5.82419 8.62544 5.9216 8.91373C6.01844 8.6288 6.18022 8.36514 6.40133 8.14402C6.88947 7.65589 7.58249 7.4566 8.25647 7.60998C8.28502 7.6167 8.30798 7.63797 8.31637 7.66652C8.32477 7.69507 8.31637 7.7253 8.29566 7.74657L6.93649 9.10574C7.13634 9.03968 7.3485 9.00442 7.56681 9.00442C8.25703 9.00442 8.88848 9.35372 9.25626 9.93814C9.27193 9.96333 9.27305 9.99468 9.2585 10.0204C9.24394 10.0462 9.21707 10.0624 9.1874 10.0624H7.26565C7.45374 10.157 7.62839 10.2824 7.78289 10.4364C8.27103 10.9245 8.47031 11.6175 8.31693 12.2915C8.31021 12.32 8.28894 12.343 8.26039 12.3514C8.25312 12.3536 8.24528 12.3548 8.238 12.3548C8.21673 12.3548 8.19602 12.3464 8.1809 12.3312L6.26195 10.4123L6.34983 15.2813C7.73923 15.2058 9.27641 14.965 10.7901 14.7277C13.4787 14.3067 16.0381 13.9065 17.8602 14.3543V14.9343C16.1333 14.4584 13.4664 14.8755 10.8768 15.2808C9.34302 15.5209 7.78569 15.7644 6.36047 15.8394L6.40749 18.4397H18.9406C19.1567 18.4397 19.3325 18.2639 19.3325 18.0478L19.3319 6.42995Z"
                    fill="#989898"
                    stroke="#989898"
                    stroke-width="0.3"
                  />
                </svg>
                <span>Photo Gallery</span>
              </a>
            </li>
          </ul>
        </div>
        <div
          class="hidden md:flex flex-col md:flex-row justify-center  mb-24 font-sans2 text-xs"
        >
          <ul
            v-for="topMenuItem in menu.menu_items"
            :id="`footer-nav-${stringToSlug(topMenuItem.name)}`"
            :key="topMenuItem.id"
            class="w-1/6 pr-4 last:mr-0"
          >
            <li
              v-for="childMenuItem in topMenuItem.children"
              :key="childMenuItem.id"
              class="py-1 px-4"
              :class="footerChildClasses(childMenuItem.name)"
            >
              <a
                :href="childMenuItem.permalink"
                :rel="childMenuItem.rel"
                class="text-glueblue-700"
              >
                {{ childMenuItem.name }}
              </a>
            </li>
          </ul>
        </div>

        <div class="flex justify-center mt-16 md:mt-0 mb-16">
          <a href="/" class="text-glueblue-700">
            <LogosAtlantisLogo style="width: 190px" />
          </a>
        </div>

        <ul class="flex justify-center text-xl">
          <li class="mx-2">
            <a
              class="text-glueblue-700"
              href="https://facebook.com/atlantisbahamas"
            >
              <Icon class="w-6 h-6" name="simple-icons:facebook" />
            </a>
          </li>
          <li class="mx-2">
            <a
              class="text-glueblue-700"
              href="https://www.youtube.com/atlantisbahamasofficial"
            >
              <Icon class="w-6 h-6" name="simple-icons:youtube" />
            </a>
          </li>
          <li class="mx-2">
            <a
              class="text-glueblue-700"
              href="https://www.pinterest.com/atlantisbahamas"
            >
              <Icon class="w-6 h-6" name="simple-icons:pinterest" />
            </a>
          </li>
          <li class="mx-2">
            <a
              class="text-glueblue-700"
              href="https://instagram.com/atlantisbahamas"
            >
              <Icon class="w-6 h-6" name="simple-icons:instagram" />
            </a>
          </li>
          <li class="mx-2">
            <a
              class="text-glueblue-700"
              href="https://twitter.com/atlantisbahamas"
            >
              <Icon class="w-6 h-6" name="simple-icons:x" />
            </a>
          </li>
        </ul>
        <div class="px-16 text-xs text-center mt-8">
          <div>
            <span
              v-for="topMenuItem in legalMenu
                .menu_items"
              :key="topMenuItem.id"
              class="border-r border-glueblue-600 last:border-r-0 pr-1 mr-1"
            >
              <a
                class="text-glueblue-600"
                :href="topMenuItem.permalink"
                v-html="topMenuItem.name"
              />
            </span>

            <span
              class="border-r border-glueblue-600 last:border-r-0 pr-1 mr-1"
            >
              <a
                v-if="!agentLoggedIn"
                class="text-glueblue-600"
                href="/travelagent"
              >Travel Advisor</a>
              <a
                v-if="agentLoggedIn"
                class="text-glueblue-600"
                href="/travelagent"
                @click="logOutTravelAgent"
              >Travel Advisor Logout</a>
            </span>
          </div>
          <div class="mt-1">
            <span
              class="border-r border-glueblue-600 last:border-r-0 pr-1 mr-1"
            >
              <a class="ot-sdk-show-settings" href="javascript:void(0)">
                Cookie Settings
              </a>
            </span>
            <span
              class="border-r border-glueblue-600 last:border-r-0 pr-1 mr-1"
            >
              <a
                href="https://privacyportal.onetrust.com/webform/1a83e5ad-9ea4-49fa-91d0-295c0bddffd1/06533f77-836b-420f-bac4-74f4315462e8"
              >Exercise Your Privacy Rights</a>
            </span>
            <span
              class="border-r border-glueblue-600 last:border-r-0 pr-1 mr-1"
            >
              <a
                href="https://privacyportal.onetrust.com/webform/1a83e5ad-9ea4-49fa-91d0-295c0bddffd1/06533f77-836b-420f-bac4-74f4315462e8"
              >Do Not Sell or Share My Personal Information</a>
            </span>
            <span
              class="border-r border-glueblue-600 last:border-r-0 pr-1 mr-1"
            >
              <a href="tel:1-800-285-2684" class="text-gray-800">1-800-Atlantis</a>
            </span>
          </div>
        </div>

        <div
          class="px-16 text-xs text-center mt-3 text-glueblue-700 opacity-75"
        >
          &copy; Atlantis. All rights reserved.
        </div>
      </div>
    </footer>
  </div>
</template>
